import { Link } from "react-router-dom";
import { Megaphone } from "lucide-react";
import { tanggal } from "@/lib/format";
import { SectionTitle } from "./SectionTitle";

export const TONE = {
  urgent: "bg-red-100 text-red-800",
  penting: "bg-[#f6ebd0] text-[#8a6d14]",
  normal: "bg-emerald-50 text-emerald-800",
};

export const AnnouncementsSection = ({ announcements = [] }) => (
  <section id="pengumuman" className="scroll-mt-24" data-testid="announcements-section">
    <SectionTitle eyebrow="Informasi Terbaru" title="Pengumuman Terbaru" desc="Informasi penting dari pengurus DKM untuk seluruh jamaah: jadwal kajian, penggalangan dana, hingga pemberitahuan kegiatan masjid." more="/pengumuman" moreTestId="announcements-see-all" />
    <div className="mt-10 grid lg:grid-cols-2 gap-5">
      {announcements.slice(0, 4).map((a) => (
        <Link to={`/pengumuman/${a.id}`} key={a.id} className="card-hover block rounded-3xl bg-white border border-emerald-900/10 p-6" data-testid={`announcement-card-${a.id}`}>
          <div className="flex items-center justify-between gap-3">
            <span className={`text-[11px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full ${TONE[a.priority] || TONE.normal}`}>{a.priority}</span>
            <span className="text-xs text-slate-400">{tanggal(a.created_at?.slice(0, 10))}</span>
          </div>
          <h3 className="mt-4 font-bold text-emerald-950 text-lg">{a.title}</h3>
          <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-3">{a.content}</p>
        </Link>
      ))}
      {announcements.length === 0 && (
        <div className="col-span-full rounded-3xl border border-dashed border-emerald-900/20 p-10 text-center text-slate-500" data-testid="announcements-empty">
          <Megaphone className="mx-auto mb-3 text-emerald-700" />
          Belum ada pengumuman.
        </div>
      )}
    </div>
  </section>
);
